<div class="content">
  <markdown class="agent-markdown" [data]="$revealedText()" (ready)="onMarkdownReady()" />
</div>
